import { Component, Input, OnInit } from '@angular/core';
import { Shipment } from '../../../models/shipment';
import { TrackingEventGroup } from '../../../models/tracking-event-group';
import { TrackingGroupComponent } from '../tracking-group/tracking-group.component';


@Component({
    selector: 'app-shipment-tracking',
    templateUrl: './shipment-tracking.component.html',
    styleUrls: ['./shipment-tracking.component.scss'],
    imports: [TrackingGroupComponent]
})
export class ShipmentTrackingComponent implements OnInit {

    public readonly COLUMN_WIDTH = 300;

    @Input()
    public shipment: Shipment;

    public groupCount = 0;
    public containerWidth = '800px';

    constructor() {
    }

    ngOnInit(): void {
        this.countGroups();
    }

    protected countGroups(): void {
        const counter = (group: TrackingEventGroup) => {
            if (group.split.length === 0) {
                this.groupCount++;
            } else {
                group.split.forEach(counter);
            }
        };
        if (this.shipment.tracking) {
            counter(this.shipment.tracking);
        }
        this.containerWidth = (this.groupCount * this.COLUMN_WIDTH) + 'px';
    }

}
